export function scale(units: number): number {
  return Math.round(units * 8)
}
